import React, { useState, useEffect, useCallback } from "react";
import teamphoto from "assets/teamphotocopy.webp";
import teamphotomobile from "assets/teamphotomobile.webp";
import LCPImage from "components/LCPImage/lcpImage";
import "styles/siteChrome.css";
import "./Hero.css";

const REGISTER_URL = `https://app.jackrabbitclass.com/regv2.asp?id=${process.env.REACT_APP_ORGID}`;
const PORTAL_URL =
  "https://app.jackrabbitclass.com/jr3.0/ParentPortal/Login?orgID=539177";

const Hero = () => {
  const [imageSrc, setImageSrc] = useState(teamphoto);
  const [width, setWidth] = useState(
    typeof window !== "undefined" ? window.innerWidth : 1200
  );
  const [heroReady, setHeroReady] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const screenWidth = window.innerWidth;
      setImageSrc(screenWidth < 449 ? teamphotomobile : teamphoto);
      setWidth(screenWidth);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      setHeroReady(true);
      return;
    }
    setHeroReady(false);
  }, [imageSrc]);

  const handleImageLoad = useCallback(() => {
    setHeroReady(true);
  }, []);

  return (
    <section
      className={`home-hero${heroReady ? " home-hero--ready" : ""}`}
      aria-label="Welcome"
    >
      <div className="home-hero__media">
        <LCPImage
          src={imageSrc}
          alt="Ace Gymnastics team at our Bardstown facility"
          className="home-hero__image"
          width={width > 449 ? "1200" : "450"}
          height={width > 449 ? "600" : "563"}
          onLoad={handleImageLoad}
        />
        <div className="home-hero__overlay" aria-hidden="true" />
      </div>
      <div className="home-hero__content">
        <p className="home-hero__eyebrow home-hero__reveal">Family-owned · Bardstown, KY</p>
        <h1 className="home-hero__title home-hero__reveal">
          <span className="visually-hidden">Ace Gymnastics — gymnastics classes in Bardstown, Kentucky. </span>
          <span className="home-hero__title-lead">Where kids are</span>
          <span className="home-hero__title-values">
            Active · Confident · Empowered
          </span>
        </h1>
        <p className="home-hero__lead home-hero__reveal">
          Premier gymnastics for ages 18 months to 18 years — recreational
          classes, competitive teams, and private lessons in a safe,
          supportive gym.
        </p>
        <div className="home-hero__actions home-hero__reveal">
          <a
            href="#find-a-class"
            className="home-btn home-btn--primary"
            data-track="home_class_finder_click"
            data-track-location="home_hero"
          >
            Find a class
          </a>
          <a
            href="#programs"
            className="home-btn home-btn--secondary"
            data-track="explore_programs_click"
            data-track-location="home_hero"
          >
            Explore Programs
          </a>
        </div>
        <a
          href={REGISTER_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="home-hero__register-link home-hero__reveal"
          data-track="register_click"
          data-track-location="home_hero"
        >
          Already know your class? Register in Jackrabbit →
        </a>
        <a
          href={PORTAL_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="home-hero__portal-link home-hero__reveal"
          data-track="parent_portal_click"
          data-track-location="home_hero"
        >
          Parent Portal login →
        </a>
      </div>
    </section>
  );
};

export default Hero;
